import React from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import { Label } from './label';
import { FieldError } from './field-error';
import { setupField } from '../utils/form-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function CheckboxField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline error={error}>
      <Label>{props.label}</Label>
      <Checkbox
        {...field}
        checked={!!field.value}
        onChange={(e, data) => {
          handleChange(e, { ...data, value: data.checked });
        }}
        onBlur={handleBlur}
        error={error}
      />
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
